// API endpoints constants

export const API = {
  LOCAL: 'http://localhost:3000/',
  CMS_SIT: 'https://cms.sit10.acquisition.genesis.ca/',
  SIT: 'https://sit10.acquisition.genesis.ca/',
  SCCMS: 'https://sccms10.acquisition.genesis.ca/',
  PROD: 'https://acquisition.genesis.ca/',
};

export const URL = {
  MODEL_STEP: 'genesis/service/GenesisShowroom/GetLatestYearModelsJson',
  TRIM_STEP: '/genesis/service/GenesisShowroom/GetTrimsJson',
  COLOR_STEP: '/genesis/service/GenesisShowroom/GetTrimColorsJson',
  ACCESSORIES_STEP: '/genesis/service/GenesisShowroom/GetAccessories',
  PROTECTION_STEP: '/genesis/service/GenesisShowroom/GetProtectionPlans',
  GET_CONFIG: '/genesis/service/BuildAndOrder/GetConfigurations',
  SAVE_CONFIG: '/api/sitecore/BuildAndOrder/SaveConfiguration',
  POPULAR_ACCESSORIES: '/genesis/service/GenesisShowroom/GetPopularAccessories',
  PAYMENT_SERVICE: '/genesis/service/GenesisShowroom/GetPaymentOptions',
  GET_PAYMENTDATA: '/genesis/service/Payments/Prices',
  GET_DEALER_DETAILS: '/genesis/service/BuildAndOrder/GetDealerDetails',
  GET_BNO_EXPERIENCE: '/genesis/service/BuildAndOrder/GetBnOExperienceList',
  GET_LEGAL_LIST: '/genesis/service/BuildAndOrder/GetLegalList',
  GET_DEALERCODE: '/genesis/service/BuildAndOrder/GetDealerByDealerId',
  POST_ROADSTER: '/genesis/service/Link/PostBuildForRoadsterLink',
  DEALER_SEARCH_NAME: '/genesis/service/GenesisDealerSearch/GetServiceDealerByName',
  DEALER_SEARCH_POSTAL: '/genesis/service/GenesisDealerSearch/GetServiceDealerDetails',
  DEALER_SEARCH_LOCATION: '/genesis/service/GenesisDealerSearch/GetServiceDealerDetails',
};
